import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './component.scss'
import 'Images/nurikae/down_arrow.svg'

const SHOW_MORE_ROOT_SELECTOR = '.js-showMore-root-target'
const SHOW_MORE_BUTTON_SELECTOR = '.js-showMore-trigger'
const SHOW_MORE_TARGET_SELECTOR = '.js-showMore-target'
const BUTTON_SHOW_CLASS_NAME = 'list-table__button--show'
const ROW_HIDE_CLASS_NAME = 'list-table__row--hide'

$(() => {
  $(SHOW_MORE_BUTTON_SELECTOR).on('click', (event) => {
    const $trigger = $(event.currentTarget)
    const $root = $trigger.closest(SHOW_MORE_ROOT_SELECTOR)
    const $target = $root.find(SHOW_MORE_TARGET_SELECTOR)

    $trigger.toggleClass(BUTTON_SHOW_CLASS_NAME)
    $target.toggleClass(ROW_HIDE_CLASS_NAME)

    // 閉じた際は、テーブルの上までスクロールして戻す
    if (!$trigger.hasClass(BUTTON_SHOW_CLASS_NAME)) {
      const rootTop = $root.offset().top
      const scrollTop = $(window).scrollTop()

      if (rootTop < scrollTop) {
        const marginTop = 120
        window.scrollTo({ top: rootTop - marginTop, behavior: 'instant' })
      }
    }
  })
})
